export default __webpack_public_path__ + "static/marketplace-og-2dbb0251a9fd032fb2532072f15fab6c.png";